"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var antd_1 = require("antd");
Object.defineProperty(exports, "Menu", { enumerable: true, get: function () { return antd_1.Menu; } });
